
import styled from 'styled-components';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';

import AppGrowMostBenefits from '../components/AppGrow/AppGrowMostBenefits';
import PlatformWebIntro from '../components/PlatformWeb/PlatformWebIntro';
import PlatformWebData from '../components/PlatformWeb/PlatformWebData';
import PlatformWebBanner from '../components/PlatformWeb/PlatformWebBanner';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";
import { lightThemeColors } from '../assets/style/colors';
import { Helmet } from 'react-helmet-async';

const PlatformWebPage = () => {
    return (
        <>
            <Helmet>
                <title>Boost Web Engagement & Conversions | Grovs</title>
                <meta
                    name="description"
                    content="Enhance your web user engagement and conversion rates with Grovs. Use intelligent links, automated messaging, and precise campaign tracking to grow your web presence."
                />
                <meta
                    name="keywords"
                    content="web engagement, user journeys, smart links, automated messaging, web attribution, conversion optimization, user retention"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Boost Web Engagement & Conversions with Grovs"
                />
                <meta
                    property="og:description"
                    content="Drive more conversions and user retention on your website with Grovs’ smart linking, automated messaging, and clear attribution."
                />
                <meta property="og:url" content="https://www.grovs.io/platform-web" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/web-engagement-social.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Boost Web Engagement & Conversions | Grovs"
                />
                <meta
                    name="twitter:description"
                    content="Enhance web user journeys and conversions with smart links and automated messaging powered by Grovs."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/web-engagement-social.jpg"
                />
            </Helmet>
            <Container>
                <PlatformWebIntro />
                <PlatformWebData />
                <PlatformWebBanner />
                <AppGrowMostBenefits />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.measureBg}
                    gradientColor={"rgba(91, 104, 223, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{ color: lightThemeColors.darkColor, background: lightThemeColors.lightColor }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Start Growing Your Web Presence"}
                    subtitle={"Join the leading brands using Grovs to drive installs, maximize engagement, and clearly measure results. Stop guessing and start growing with confidence."}
                />
                <TrackingComponent />
            </Container>
        </>
    )
}

export default PlatformWebPage

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;